import { render, staticRenderFns } from "./saveMoreOffers.vue?vue&type=template&id=7f0ae1ed&scoped=true&"
import script from "./saveMoreOffers.vue?vue&type=script&lang=js&"
export * from "./saveMoreOffers.vue?vue&type=script&lang=js&"
import style0 from "./saveMoreOffers.vue?vue&type=style&index=0&id=7f0ae1ed&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ae1ed",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
